<template>
  <b-form @submit.prevent="sendComment()">
    <b-form-group
      :label="isAnswerForm ? '' : 'Ваш комментарий:'"
      :label-class="{cursor: small, 'pb-0': toggled, hover: small}"
      :class="{'mb-0': toggled}"
    >
      <template v-if="!isAnswerForm" #label>
        <span @click="toggle()">Ваш комментарий:</span>
      </template>
      <b-form-textarea
        v-show="!toggled"
        v-model="message"
        @keyup.ctrl.enter="sendComment()"
      />
    </b-form-group>
    <b-button v-if="isAnswerForm" size="sm" variant="secondary" class="float-right ml-2" @click="closeForm()">Закрыть</b-button>
    <b-button v-show="!toggled" type="send" size="sm" variant="primary" class="float-right" :disabled="message.length === 0 && !sending">
      Отправить
      <font-awesome-icon v-if="sending" :icon="['fas', 'spinner']" spin></font-awesome-icon>
      <font-awesome-icon v-else :icon="['fas', 'share']"></font-awesome-icon>
    </b-button>
    <p v-show="!toggled" class="small">Ctrl-Enter - отправить комментарий.</p>
  </b-form>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'CommentForm',
  props: {
    type: {
      type: String,
      required: true
    },
    object: {
      type: Object,
      required: true
    },
    parent: {
      type: Object,
      default: null
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    sending: false,
    message: '',
    toggled: false
  }),
  computed: {
    ...mapState('ParishModule', {
      parish: 'current'
    }),
    isAnswerForm () {
      return !!this.parent
    }
  },
  beforeMount () {
    this.toggled = this.small
  },
  methods: {
    toggle () {
      if (this.small) {
        this.toggled = !this.toggled
      }
    },
    async sendComment () {
      this.sending = true
      try {
        switch (this.type) {
          case 'post':
            await this.$store.dispatch('BlogModule/sendCommentForPost', { post: this.object, message: this.message, parent: this.parent })
            break
          case 'photo':
            await this.$store.dispatch('BlogModule/sendCommentForPhoto', { photo: this.object, message: this.message, parent: this.parent })
            break
          case 'video':
            await this.$store.dispatch('BlogModule/sendCommentForVideo', { video: this.object, message: this.message, parent: this.parent })
            break
          default:
            throw new Error('unknown object type for comment')
        }
        this.message = ''
        this.closeForm()
      } catch (error) {
        console.log(error)
      }
      this.sending = false
    },
    closeForm () {
      this.toggled = this.small
      this.$emit('close')
    }
  }
}
</script>
